const actionsScope = 'AUTH/CHANGE_PASSWORD';

export const CHANGE_PASSWORD_TYPES = {
  PROCEED: `${actionsScope}/PROCEED`,
  CONFIRM: `${actionsScope}/CONFIRM`,
};



// WEBPACK FOOTER //
// ./src/redux/auth/changePassword/constants.js